import { useTranslation } from 'react-i18next';
import Banner from '../../components/Banner/Banner';
import RestoreForm from './RestoreForm';

const RestorePassword = () => {
  const { t } = useTranslation();
  return (
    <>
      <Banner title={t('banner.forgotPassword')}></Banner>
      <RestoreForm/>
    </>
  );
};

export default RestorePassword;
